import React from 'react';
import { X } from 'lucide-react';

interface CanvasHeaderProps {
  systemConfig: { Id: string; ConfigValue: string; }[];
  onClose: () => void;
}

const CanvasHeader: React.FC<CanvasHeaderProps> = ({
  systemConfig,
  onClose
}) => {
  const maxCourses = Number(systemConfig.find(item => item.Id === 'va_max_allowed_canvas_course')?.ConfigValue) || 5;

  return (
    <div className="pl-3 pr-3 pb-3 pt-2 shadow-md sticky top-0 z-10">
      <div className="flex justify-between items-center">
        <div className="flex items-center space-x-2">
          <img src="/canvas-logo.svg" alt="Canvas Logo" className="h-5 w-5" />
          <h2 className="text-xl font-semibold text-gray-800">Canvas Course Sites</h2>
        </div>
        <button
          onClick={onClose}
          className="text-gray-500 hover:text-gray-700"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
      <p className="text-gray-600 mt-2 ml-8">
        Setup your Chatbot to train itself with content on your Canvas course sites.
        This includes only published content if and when it is released to students.
        You can specify up to {maxCourses} courses.
      </p>
    </div>
  );
};

export default CanvasHeader;